import React from 'react';
import styles from './LoadingSpinner.module.css';

/**
 * 🔄 Loading Spinner — marka token'larıyla, lazy/Suspense fallback'i.
 * size: sm | md | lg   fullPage: tam yükseklik ortalanmış kapsayıcı
 */
const LoadingSpinner = ({ message = 'Yükleniyor...', size = 'lg', fullPage = true, className = '' }) => {
  return (
    <div
      className={`${fullPage ? styles.wrapper : styles.inline} ${className}`}
      role="status"
      aria-live="polite"
    >
      <span className={`${styles.spinner} ${styles[size] || styles.lg}`} aria-hidden="true" />
      {message && <p className={styles.message}>{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
